import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="booking-summary"
export default class extends Controller {
  connect() {

  }
  
  toggle() {
    this.element.classList.toggle('closed');
  }

}
